import { useEffect, useState } from "react";

export function useTimer({ expiresAt, expiresIn, onExpired }) {
  const [timeLeft, setTimeLeft] = useState<number>(0);

  useEffect(() => {
    if(expiresAt){
      const interval = setInterval(() => {
        const expireTime = new Date(expiresAt).getTime();
        const now = Date.now();
        const diff = expireTime - now;
  
        if (diff <= 0) {
          setTimeLeft(0);
          clearInterval(interval);
          onExpired()
          return;
        }
  
        const seconds = Math.floor((diff / 1000));
        setTimeLeft(seconds);
      }, 1000);
  
      return () => clearInterval(interval);
    }
  }, [expiresAt]);

  return {
    timeLeft,
    progress: timeLeft / expiresIn,
  }
}
